import React from "react";
import UserProfile from "../../components/Profile/UserProfile";
import Footer from "../../components/Common/Footer"

const PublicProfileUrl = (props) => {
  return (
    <div className={"publicContainer"}>
      <div className={"publicWrapper publicsections"}>
        <UserProfile {...props}/>
      </div>
      <Footer />
    </div>
  )
}

export default PublicProfileUrl;